import { minDiscountedAcrossWeek, minStayPriceAcrossRooms } from './roomDayPricing';

/** Doc import default when no parseable rate — treat as not yet bookable. */
export const COMING_SOON_PLACEHOLDER_PRICE = 4500;

export function isComingSoonDiscountedPrice(discountedPrice) {
  const dp = Number(discountedPrice);
  if (!Number.isFinite(dp)) return true;
  return dp === 0 || dp === COMING_SOON_PLACEHOLDER_PRICE;
}

/** Catalog min discounted (weekdays + guest tiers) for an API room. */
export function getRoomCatalogMinDiscounted(room) {
  if (!room) return 0;
  return minDiscountedAcrossWeek(room);
}

export function isRoomComingSoon(room) {
  return isComingSoonDiscountedPrice(getRoomCatalogMinDiscounted(room));
}

/** True when every room in the stay uses placeholder pricing. */
export function isStayComingSoon(stay) {
  const rooms = stay?.rooms;
  if (!Array.isArray(rooms) || rooms.length === 0) return false;
  return rooms.every(isRoomComingSoon);
}

/** Lowest catalog price among rooms that are actually bookable. */
export function getStayBookableMinPrice(stay) {
  const rooms = stay?.rooms;
  if (!Array.isArray(rooms) || !rooms.length) return null;
  const mins = rooms
    .map((r) => getRoomCatalogMinDiscounted(r))
    .filter((dp) => !isComingSoonDiscountedPrice(dp));
  return mins.length ? Math.min(...mins) : null;
}

export function bookableRooms(rooms) {
  if (!Array.isArray(rooms)) return [];
  return rooms.filter((r) => !isRoomComingSoon(r));
}

/** Date-aware “from” price, excluding coming-soon rooms. */
export function minStayBookablePriceAcrossRooms(rooms, checkInYmd, checkOutYmd, adults = null) {
  const eligible = bookableRooms(rooms);
  if (!eligible.length) return null;
  return minStayPriceAcrossRooms(eligible, checkInYmd, checkOutYmd, adults);
}

/** For RoomSelection mapped cards (`price` is per-night display). */
export function isMappedRoomComingSoon(mappedRoom) {
  if (!mappedRoom) return true;
  if (mappedRoom.comingSoon === true) return true;
  if (typeof mappedRoom.price !== 'number') return true;
  return isComingSoonDiscountedPrice(mappedRoom.price);
}
